import React, { useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, Box, CircularProgress } from '@mui/material';
import 'react-dropzone-uploader/dist/styles.css'
import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Counter from "yet-another-react-lightbox/plugins/counter";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import { Masonry } from "@mui/lab";
import { useGalleryPhotographs } from '../../../hooks/useGalleries';

interface ISingleGalleryDialogProps {
    open: boolean;
    setOpen: (value: boolean) => void;
    galleryId: number;
    setGalleryId: (id: number) => void;
}

export function SingleGalleryDialog({
    open,
    setOpen,
    galleryId,
    setGalleryId,
}: ISingleGalleryDialogProps) {
    const [index, setIndex] = useState<number>(-1);
    const { data: photographsData, isLoading } = useGalleryPhotographs(galleryId);

    const handleClose = () => {
        setGalleryId(-1);
        setOpen(false);
    };

    return (
        <Dialog open={open} fullWidth maxWidth={'xl'} onClose={handleClose}>
            <DialogTitle>Album</DialogTitle>
            <Button 
                sx={{ position: "absolute", top: "1rem", right: "1rem" }} 
                variant="contained" 
                onClick={handleClose}
            >
                Close
            </Button>
            <DialogContent sx={{ p: 5, textAlign: "center", minHeight: "80vh", padding: 0, margin: 0 }}>
                {isLoading ? (
                    <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
                        <CircularProgress color="inherit" />
                    </Box>
                ) : (
                    <>
                        <Lightbox
                            open={index >= 0}
                            close={() => setIndex(-1)}
                            slides={photographsData || []}
                            index={index}
                            plugins={[Captions, Fullscreen, Thumbnails, Zoom, Counter]}
                            styles={{
                                root: {
                                    "--yarl__color_backdrop": "#fff",
                                    "--yarl__color_button": "#444",
                                    "--yarl__color_button_active": "#000",
                                },
                            }}
                        />
                        <Masonry 
                            sx={{ overflowX: "hidden", m: 0 }} 
                            columns={{ xs: 1 }} 
                            spacing={0}
                        >
                            {(photographsData || []).map((item: any, idx: number) => (
                                <Box 
                                    key={item.id}
                                    onClick={() => setIndex(idx)}
                                    sx={{
                                        cursor: 'pointer',
                                        transition: "transform 0.2s ease",
                                        '&:hover': { transform: 'scale(1.01)' }
                                    }}
                                >
                                    <img
                                        src={item.src}
                                        alt='eseruyanik'
                                        style={{ width: '100%', maxHeight: "80vh", objectFit: 'contain' }}
                                    />
                                </Box>
                            ))}
                        </Masonry>
                    </>
                )}
            </DialogContent>
        </Dialog>
    );
}
